var map = {
	"./Tamilnadu-Assembly-NEW.svg": 179,
	"./action.svg": 208,
	"./adventure.svg": 209,
	"./advertorial.svg": 210,
	"./ai.svg": 211,
	"./album.svg": 212,
	"./analysis.svg": 213,
	"./anchor.svg": 214,
	"./android-block.svg": 215,
	"./android-small.svg": 216,
	"./android.svg": 217,
	"./angle-down.svg": 218,
	"./angle-left.svg": 219,
	"./angle-right.svg": 220,
	"./angle-up.svg": 221,
	"./aquarius.svg": 222,
	"./arcade.svg": 223,
	"./aries.svg": 224,
	"./arrow-down.svg": 225,
	"./arrow-left.svg": 226,
	"./arrow-right.svg": 227,
	"./arrow-up.svg": 228,
	"./arrow.svg": 229,
	"./art-director.svg": 230,
	"./astrology.svg": 231,
	"./author-avator.svg": 232,
	"./author.svg": 233,
	"./authoranchor.svg": 234,
	"./authorwhite.svg": 235,
	"./automobile.svg": 236,
	"./backward.svg": 237,
	"./bookmark.svg": 238,
	"./books-vikatan.svg": 239,
	"./brandconnect.svg": 240,
	"./breaking-news.svg": 241,
	"./bullet-arrow.svg": 242,
	"./bundle.svg": 243,
	"./business.svg": 244,
	"./calendar.svg": 245,
	"./cancel.svg": 246,
	"./cancer.svg": 247,
	"./canvas.svg": 248,
	"./capricorn.svg": 249,
	"./cartoonist.svg": 250,
	"./cinema.svg": 251,
	"./clapboard.svg": 252,
	"./clipboard.svg": 253,
	"./close.svg": 254,
	"./comment.svg": 255,
	"./corona-updates-icon.svg": 256,
	"./creative-director.svg": 257,
	"./cricket.svg": 258,
	"./crime.svg": 259,
	"./data.svg": 260,
	"./designed.svg": 261,
	"./double-arrow.svg": 262,
	"./downarrow.svg": 263,
	"./download.svg": 264,
	"./edit.svg": 265,
	"./edited-by.svg": 266,
	"./election-2026.svg": 267,
	"./email.svg": 268,
	"./environment.svg": 269,
	"./exclusivedeals.svg": 270,
	"./facebook-bg.svg": 271,
	"./facebook-icon.svg": 272,
	"./facebook.svg": 273,
	"./filter-icon.svg": 274,
	"./filter.svg": 275,
	"./food-stylist.svg": 276,
	"./forward.svg": 277,
	"./gallery.svg": 278,
	"./game-shop.svg": 279,
	"./gemini.svg": 280,
	"./group.svg": 281,
	"./gzhome.svg": 282,
	"./gzsports.svg": 283,
	"./gztrending.svg": 284,
	"./health.svg": 285,
	"./hexbackground.svg": 286,
	"./home.svg": 287,
	"./humoursatire-entertainment.svg": 288,
	"./icon-apple.svg": 289,
	"./icon-appstore.svg": 290,
	"./icon-audio-app-store.svg": 291,
	"./icon-audio-fb.svg": 292,
	"./icon-audio-instagram.svg": 293,
	"./icon-audio-next.svg": 294,
	"./icon-audio-play-store.svg": 295,
	"./icon-audio-previous.svg": 296,
	"./icon-audio-twitter.svg": 297,
	"./icon-audio-whatsapp.svg": 298,
	"./icon-copy.svg": 299,
	"./icon-election.svg": 300,
	"./icon-episode.svg": 301,
	"./icon-facebook.svg": 302,
	"./icon-google-play.svg": 303,
	"./icon-headset.svg": 304,
	"./icon-home-plus.svg": 305,
	"./icon-login.svg": 306,
	"./icon-open-in-new.svg": 307,
	"./icon-pause.svg": 308,
	"./icon-play.svg": 309,
	"./icon-playstore.svg": 310,
	"./icon-premium.svg": 311,
	"./icon-share.svg": 312,
	"./icon-star.svg": 313,
	"./icon-timer.svg": 314,
	"./icon-twitter.svg": 315,
	"./icon-user.svg": 316,
	"./icon-video.svg": 317,
	"./icon-whatsapp.svg": 318,
	"./illustrator-t1.svg": 319,
	"./illustrator.svg": 320,
	"./infographer.svg": 321,
	"./instagram.svg": 322,
	"./interviews.svg": 323,
	"./ios-block.svg": 324,
	"./ios-small.svg": 325,
	"./ios.svg": 326,
	"./jokes.svg": 327,
	"./leo.svg": 328,
	"./libra.svg": 329,
	"./lifestyle.svg": 330,
	"./line-arrow-next.svg": 331,
	"./line-arrow-prev.svg": 332,
	"./linkedin.svg": 333,
	"./listicle.svg": 334,
	"./live-chat.svg": 335,
	"./liveupdate.svg": 336,
	"./log green.svg": 337,
	"./log grey.svg": 338,
	"./log white.svg": 339,
	"./logic.svg": 340,
	"./login-facebook.svg": 341,
	"./login-google.svg": 342,
	"./login.svg": 343,
	"./logout-mobile.svg": 344,
	"./logout.svg": 345,
	"./longform.svg": 346,
	"./magazines.svg": 347,
	"./mail.svg": 348,
	"./menu-search.svg": 349,
	"./microphone.svg": 350,
	"./minus.svg": 351,
	"./mobile-share.svg": 352,
	"./moderated.svg": 353,
	"./more-outline.svg": 354,
	"./my-vikatan-logo.svg": 355,
	"./mynews.svg": 356,
	"./myvikatanbadge.svg": 357,
	"./narrated.svg": 358,
	"./news.svg": 359,
	"./newsletter.svg": 360,
	"./newslettericon.svg": 361,
	"./olympic.svg": 362,
	"./online-news.svg": 363,
	"./pause.svg": 364,
	"./pdf.svg": 365,
	"./pen.svg": 366,
	"./personalise.svg": 367,
	"./phone.svg": 368,
	"./photo.svg": 369,
	"./photographer.svg": 370,
	"./photostory.svg": 371,
	"./pisces.svg": 372,
	"./play.svg": 373,
	"./plus.svg": 374,
	"./podcast.svg": 375,
	"./podcast_vikatan_menu.svg": 376,
	"./poems.svg": 377,
	"./politics.svg": 378,
	"./premium.svg": 379,
	"./producer.svg": 380,
	"./proofread.svg": 381,
	"./published-by.svg": 382,
	"./published.svg": 383,
	"./rain.svg": 384,
	"./rss.svg": 385,
	"./rupee.svg": 386,
	"./sagitarius.svg": 387,
	"./scorpio.svg": 388,
	"./script-writer.svg": 389,
	"./scripted.svg": 390,
	"./search.svg": 391,
	"./share-alt.svg": 392,
	"./share.svg": 393,
	"./sharechat.svg": 394,
	"./shortform.svg": 395,
	"./shortstories.svg": 396,
	"./shortvideo.svg": 397,
	"./slider-next.svg": 398,
	"./slider-prev.svg": 399,
	"./socialshare.svg": 400,
	"./sort.svg": 401,
	"./sound.svg": 402,
	"./speaker.svg": 403,
	"./speakeraudio.svg": 404,
	"./spiritual.svg": 405,
	"./sponsored.svg": 406,
	"./sports.svg": 407,
	"./star.svg": 408,
	"./stories.svg": 409,
	"./strategy.svg": 410,
	"./stylist.svg": 411,
	"./subscribe-vikatan.svg": 412,
	"./success-icon.svg": 413,
	"./tag.svg": 414,
	"./tamilnadu.svg": 415,
	"./taurus.svg": 416,
	"./technology.svg": 417,
	"./text.svg": 418,
	"./textsms.svg": 419,
	"./thodargal.svg": 420,
	"./thump.svg": 421,
	"./tick.svg": 422,
	"./trending.svg": 423,
	"./twitter-icon.svg": 424,
	"./twitter.svg": 425,
	"./uparrow.svg": 426,
	"./update-black.svg": 427,
	"./user-square.svg": 428,
	"./user.svg": 429,
	"./v-plus-logo.svg": 430,
	"./video-editor.svg": 431,
	"./video-icon.svg": 432,
	"./video-play.svg": 433,
	"./video.svg": 434,
	"./videographer.svg": 435,
	"./vikatan-play-logo-red.svg": 436,
	"./vikatan-play.svg": 437,
	"./vikatan-tv.svg": 438,
	"./vikatan.svg": 439,
	"./vikatanconnect.svg": 440,
	"./vikatanplay.svg": 441,
	"./vikatanspl.svg": 442,
	"./vikatantv.svg": 443,
	"./virgo.svg": 444,
	"./whatsapp-icon.svg": 445,
	"./whatsapp-icon1.svg": 446,
	"./whatsapp.svg": 447,
	"./women-home.svg": 448,
	"./writtenarticles.svg": 449,
	"./writtenstory.svg": 450,
	"./youtube.svg": 451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;